/*! Copyright 2026 Fonticons, Inc. - https://webawesome.com/license */
import {
  i
} from "./chunk.E4Q7ZNYW.js";

// _bundle_/src/components/combobox/combobox.styles.ts
var combobox_styles_default = i`
  :host {
    --tag-max-size: 10ch;
    --show-duration: var(--wa-transition-fast);
    --hide-duration: var(--wa-transition-fast);

    /*
     * The expand icon and spinner both read their cross-fade from these. The state rules below flip only the delay
     * and never re-declare the transition shorthand, so reduced motion can zero the duration in one place.
     */
    --_spinner-fade-duration: var(--wa-transition-fast);
    --_spinner-fade-delay: 0s;
  }

  /* Add ellipses to multi select options */
  :host wa-tag::part(content) {
    display: initial;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: var(--tag-max-size);
  }

  :host .disabled,
  :host .disabled * {
    cursor: not-allowed;
  }

  :host .disabled [part~='combobox'] {
    opacity: 0.5;
    outline: none;
  }

  :host .enabled:is(.open, :focus-within) [part~='combobox'] {
    outline-color: var(--wa-color-focus);
  }

  /** The popup */
  .combobox-popup {
    flex: 1 1 auto;
    display: inline-flex;
    width: 100%;
    position: relative;
    vertical-align: middle;

    /* Pass through from combobox to the popup */
    --show-duration: inherit;
    --hide-duration: inherit;

    &::part(popup) {
      z-index: 900;
    }

    &[data-current-placement^='top']::part(popup) {
      transform-origin: bottom;
    }

    &[data-current-placement^='bottom']::part(popup) {
      transform-origin: top;
    }
  }

  /* Combobox container */
  .combobox {
    flex: 1;
    display: flex;
    width: 100%;
    min-width: 0;
    align-items: center;
    justify-content: start;

    min-height: var(--wa-form-control-height);

    background-color: var(--wa-form-control-background-color);
    border-color: var(--wa-form-control-border-color);
    border-radius: var(--wa-form-control-border-radius);
    border-style: var(--wa-form-control-border-style);
    border-width: var(--wa-form-control-border-width);
    color: var(--wa-form-control-value-color);
    cursor: text;
    font-family: inherit;
    font-weight: var(--wa-form-control-value-font-weight);
    line-height: var(--wa-form-control-value-line-height);
    overflow: hidden;
    padding: 0 var(--wa-form-control-padding-inline);
    position: relative;
    vertical-align: middle;
    transition:
      background-color var(--wa-transition-normal),
      border-color var(--wa-transition-normal),
      outline-color var(--wa-transition-fast);
    transition-timing-function: var(--wa-transition-easing);
    outline: var(--wa-focus-ring-style) var(--wa-focus-ring-width) transparent;
    outline-offset: var(--wa-focus-ring-offset);

    /* Pills */
    :host([pill]) & {
      border-radius: var(--wa-border-radius-pill);
    }

    :host([pill][multiple]) & {
      border-radius: 1.4em;
    }
  }

  /* Appearance modifiers */
  :host([appearance='outlined']) .combobox {
    background-color: var(--wa-form-control-background-color);
    border-color: var(--wa-form-control-border-color);
  }

  :host([appearance='filled']) .combobox {
    background-color: var(--wa-color-neutral-fill-quiet);
    border-color: var(--wa-color-neutral-fill-quiet);
  }

  :host([appearance='filled-outlined']) .combobox {
    background-color: var(--wa-color-neutral-fill-quiet);
    border-color: var(--wa-form-control-border-color);
  }

  /* The editable input */
  .combobox-input {
    position: relative;
    flex: 1 1 auto;
    width: auto;
    min-width: 50px;
    min-height: 1.5lh;
    font: inherit;
    border: none;
    background: none;
    line-height: var(--wa-form-control-value-line-height);
    color: var(--wa-form-control-value-color);
    cursor: text;
    overflow: hidden;
    padding: 0;
    margin: 0;
    -webkit-appearance: none;

    &:focus {
      outline: none;
    }

    &::placeholder {
      color: var(--wa-form-control-placeholder-color);
    }
  }

  /* Manage spacing when tags are present */
  :host([multiple]) {
    --_padding-with-tags: calc(var(--wa-form-control-height) * 0.1 - var(--wa-form-control-border-width));

    & .combobox:has(.tags wa-tag) {
      padding-block: var(--_padding-with-tags);
      padding-inline-start: var(--_padding-with-tags);

      /* Share input space with tags */
      & .combobox-input {
        flex: 1 1 auto;
        min-width: 10em;
        margin-inline-start: 0.25em;
      }
    }
  }

  .value-input {
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    padding: 0;
    margin: 0;
  }

  .tags {
    display: flex;
    flex: 1;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.25em;
  }

  .tags wa-tag {
    cursor: pointer;
  }

  /* Nested inside the box, so a step down from the box's radius */
  .tags wa-tag:not([pill]) {
    border-radius: var(--wa-border-radius-s);
  }

  .disabled .tags,
  .disabled .tags wa-tag {
    cursor: not-allowed;
  }

  /* Start and End */
  .start,
  .end {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    color: var(--wa-color-neutral-on-quiet);
  }

  .end::slotted(*) {
    margin-inline-start: var(--wa-form-control-padding-inline);
  }

  .start::slotted(*) {
    margin-inline-end: var(--wa-form-control-padding-inline);
  }

  :host([multiple]) .combobox:has(.tags wa-tag) .start::slotted(*) {
    margin-inline-start: calc(var(--wa-form-control-padding-inline) - var(--_padding-with-tags));
  }

  /* Clear button */
  [part~='clear-button'] {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: inherit;
    color: var(--wa-color-neutral-on-quiet);
    border: none;
    background: none;
    padding: 0;
    transition: color var(--wa-transition-normal);
    cursor: pointer;
    margin-inline-start: var(--wa-form-control-padding-inline);

    &:focus {
      outline: none;
    }

    @media (hover: hover) {
      &:hover {
        color: color-mix(in oklab, currentColor, var(--wa-color-mix-hover));
      }
    }

    &:active {
      color: color-mix(in oklab, currentColor, var(--wa-color-mix-active));
    }
  }

  /* Expand icon */
  .expand-icon {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    color: var(--wa-color-neutral-on-quiet);
    transition:
      rotate var(--wa-transition-slow) var(--wa-transition-easing),
      opacity var(--_spinner-fade-duration) var(--wa-transition-easing) var(--_spinner-fade-delay);
    rotate: 0deg;

    .open & {
      rotate: -180deg;
    }
  }

  /* The expand icon and spinner share one box and cross-fade, so swapping them can't shift the field's layout */
  .trailing-affordance {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    position: relative;
    margin-inline-start: var(--wa-form-control-padding-inline);
  }

  /* Out of flow, so only the expand icon determines the trailing affordance's size */
  .spinner {
    position: absolute;
    inset-inline-start: 50%;
    inset-block-start: 50%;
    translate: -50% -50%;
    font-size: 1em;
    color: var(--wa-color-neutral-on-quiet);
    opacity: 0;
    pointer-events: none;
    transition: opacity var(--_spinner-fade-duration) var(--wa-transition-easing) var(--_spinner-fade-delay);
  }

  /* Only the fade IN waits, so a request that resolves quickly never flashes a spinner */
  :host(:state(loading)) {
    --_spinner-fade-delay: 300ms;
  }

  :host(:state(loading)) .spinner {
    opacity: 1;
  }

  :host(:state(loading)) .expand-icon {
    opacity: 0;
  }

  /* The listbox's loading row already has a spinner; a second one in the field reads as two things loading */
  :host(:state(showing-loading-row)) {
    --_spinner-fade-delay: 0s;
  }

  :host(:state(showing-loading-row)) .spinner {
    opacity: 0;
  }

  :host(:state(showing-loading-row)) .expand-icon {
    opacity: 1;
  }

  /* No cross-fade, but keep the delay so quick responses still don't flash a spinner */
  @media (prefers-reduced-motion: reduce) {
    :host {
      --_spinner-fade-duration: 0s;
    }
  }

  /* Listbox */
  .listbox {
    display: block;
    position: relative;
    font: inherit;
    box-shadow: var(--wa-shadow-m);
    background: var(--wa-color-surface-raised);
    border-color: var(--wa-color-surface-border);
    border-radius: var(--wa-border-radius-m);
    border-style: var(--wa-border-style);
    border-width: var(--wa-border-width-s);
    padding: 0.25em;
    overflow: auto;
    overscroll-behavior: none;

    /* Make sure it adheres to the popup's auto size */
    max-width: var(--auto-size-available-width);
    max-height: var(--auto-size-available-height);
  }

  slot:not([name])::slotted(wa-divider) {
    --spacing: 0.5em;
  }

  /* Space options with half the listbox's padding */
  .listbox slot:not([name]) {
    display: flex;
    flex-direction: column;
    gap: 0.125em;
  }

  /*
   * Status rows (loading, no results, empty, error). Outside role="listbox" so it never contains non-option children.
   * Padding and line-height mirror wa-option's so the popup keeps its height when options replace the row. Both
   * resolve from font-size, not --wa-form-control-height, which themes scale independently of an option's box.
   */
  .status {
    display: flex;
    align-items: center;
    gap: 0.5em;
    padding-block: 0.5em;
    padding-inline: var(--wa-space-m);
    line-height: var(--wa-line-height-condensed);
    /* Not --wa-color-text-quiet: 3.77:1 on the raised surface fails WCAG AA, and this is the listbox's only content */
    color: var(--wa-color-text-normal);
    user-select: none;
    -webkit-user-select: none;
  }

  .status-spinner {
    font-size: 1em;
    flex: 0 0 auto;
  }

  slot:not([name])::slotted(small) {
    display: block;
    font-size: var(--wa-font-size-smaller);
    font-weight: var(--wa-font-weight-semibold);
    color: var(--wa-color-text-quiet);
    padding-block: 0.5em;
    padding-inline: 2.25em;
  }

  /* Hide filtered-out elements */
  slot:not([name])::slotted([hidden]) {
    display: none !important;
  }

  /* The element that actually carries role="listbox" is a transparent wrapper around the default slot. */
  .listbox-options {
    display: block;
  }
`;

export {
  combobox_styles_default
};
